import React, { createContext } from 'react';
import { useLazyQuery, useApolloClient } from 'react-apollo';
import GET_ORGS_BASIC_DETAILS from '../../GraphQl/Queries/GET_ORGS_BASIC_DETAILS';

const OrgContext = createContext();

export const OrgProvider = ({ children }) => {
  const client = useApolloClient();
  const [
    fetchBasicOrgsDetails,
    { data: basicOrgsDetails, loading: basicOrgsDetailsLoading, error },
  ] = useLazyQuery(GET_ORGS_BASIC_DETAILS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const queryOrgs = async (variables) => {
    const result = await client.query({
      query: GET_ORGS_BASIC_DETAILS,
      variables,
    });
    return result.data;
  };

  return (
    <OrgContext.Provider
      value={{
        fetchBasicOrgsDetails,
        queryOrgs,
        basicOrgsDetails: (basicOrgsDetails && basicOrgsDetails.orgs) || [],
        basicOrgsDetailsLoading,
        error,
      }}
    >
      {children}
    </OrgContext.Provider>
  );
};

export default OrgContext;
